<template>
  <div>
    <!-- 条件筛选 -->
    <el-card>
      <el-form :model="form" ref="userform" :inline="true">
        <el-form-item label="用户昵称:">
          <el-input
            placeholder="请输入用户昵称"
            v-model="form.nickname"
            style="width: 350px;"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户手机:">
					<el-input placeholder="请输入用户手机" v-model="form.tel" style="width: 350px;"></el-input>
				</el-form-item> -->
        <el-form-item label="订单编号:">
          <el-input
            placeholder="请输入订单编号"
            v-model="form.orderid"
            style="width: 350px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态:">
          <el-select v-model="formtype" placeholder="请选择状态">
            <el-option label="待上传发票" value="99"></el-option>
            <el-option label="待处理" value="1"></el-option>
            <el-option label="已处理" value="2"></el-option>
            <el-option label="已拒绝" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调整日期:">
          <el-date-picker
            v-model="form.time"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm()">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm()">重置</el-button>
        </el-form-item>
        <download-excel
          style="margin-left: 13px;"
          class="export-excel-wrapper"
          :data="tableData"
          :fields="json_fields"
          :header="title"
          type="xls"
          name="提现统计导出.xls"
        >
          <el-button type="success">导出当前页</el-button>
        </download-excel>
      </el-form>
    </el-card>
    <!-- 列表 -->
    <el-card>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="index" label="序号" width="50">
        </el-table-column>
        <!-- <el-table-column prop="uid" label="用户id" width="50">
				</el-table-column> -->
        <el-table-column prop="nickname" label="用户昵称"> </el-table-column>
        <el-table-column prop="mechant.name" label="公司名称">
          <!-- <template slot-scope="scope">
				<el-button size="small" @click="submituserinfo(scope.row)">{{scope.row.enter_name}}</el-button> 
			</template> -->
        </el-table-column>
        <el-table-column prop="mechant.blank_account" label="收款账号">
        </el-table-column>
        <el-table-column prop="mechant.blank" label="开户银行名称">
        </el-table-column>
        <!-- <el-table-column prop="log_time" label="提现平台">
					<template slot-scope="scope">
						<div>支付宝</div>
					</template>
				</el-table-column> -->
        <!-- <el-table-column prop="account" label="提现账号">
				</el-table-column> -->
        <el-table-column prop="price" label="提现金额"> </el-table-column>
        <el-table-column prop="order_num" label="订单编号"> </el-table-column>
        <el-table-column prop="start_time" label="提现时间"> </el-table-column>
        <el-table-column prop="declaretype" label="类型"> </el-table-column>
        <el-table-column label="发票">
          <template slot-scope="scope">
            <a :href="scope.row.invoice_img" target="_blank">
              <img
                :src="scope.row.invoice_img"
                v-if="scope.row.state >= 1"
                width="50px"
              />
              <img
                v-else
                src="https://chuoooo.com/_nuxt/img/notAvailable.10bbb3b.png"
                width="50px"
              />
            </a>
          </template>
        </el-table-column>
        <el-table-column label="收益详情">
          <template slot-scope="scope">
            <el-button
              type="primary"
              plain
              size="small"
              @click="submituserinfo(scope.row)"
              >查看详情</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="start_time" label="操作" width="200">
          <template slot-scope="scope">
            <div v-if="scope.row.state == 0" style="">
              <el-button type="primary" plain size="small"
                >待对方上传发票</el-button
              >
            </div>
            <div v-else-if="scope.row.state == 1">
              <!-- <el-button type="warning" size="small">
                                待转账
                            </el-button> -->
              <el-button
                type="primary"
                plain
                size="small"
                @click="openagree(scope.row)"
                >已转账</el-button
              >
              <el-button
                type="danger"
                plain
                size="small"
                @click="submitpass(2, scope.row.order_num)"
                >拒绝</el-button
              >
            </div>
            <div v-else-if="scope.row.state == 2">
              <el-button size="small">
                已处理
              </el-button>
            </div>
            <div v-else>
              <el-button type="danger" size="small">已拒绝</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pageing
        :page="page"
        :size="size"
        :total="total"
        @current-change="handleChangePage"
      ></Pageing>
    </el-card>
    <!-- 用户历史交易列表 -->
    <el-dialog title="用户历史交易列表" :visible.sync="dialogFormVisible">
			<div>
				用户姓名：<el-input v-model="userinfo.name" disabled style="width: 150px;"></el-input>
				用户账户：<el-input v-model="userinfo.id" disabled style="width: 200px;"></el-input>
			</div>
			<div style="margin: 10px 0;">
				用户手机：<el-input v-model="userinfo.tel" disabled style="width: 150px;"></el-input>
				身份证号：<el-input v-model="userinfo.idcard" disabled style="width: 200px;"></el-input>
			</div>
			<el-table :data="userinfolist" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="log_time" label="交易状态">
					<template slot-scope="scope">
						<div>
							{{scope.row.state == '1'? "成功":scope.row.state == '0'?'进行中':'已拒绝'}}
						</div>
						<div></div>
					</template>
				</el-table-column>
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				<el-table-column  label="查看详情" >
					<template slot-scope="scope">
						<div style="cursor: pointer;" v-if="scope.row.type ==5" @click="golook(scope.row)">
							委托收入明细
						</div>
						<div style="cursor: pointer;" v-if="scope.row.type ==12" @click="golookreward(scope.row)">
							打赏收入明细
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="userinfopage" :size="userinfosize" :total="userinfototal"
					@current-change="handleChangeuserPage"></Pageing>
			</div>
		</el-dialog>
		<el-dialog title="交易委托详情" :visible.sync="golookentrustform">
			<div>
				委托名称：<el-input v-model="enteruser.entername" disabled style="width: 150px;"></el-input>
				甲方昵称：<el-input v-model="enteruser.enteruser" disabled style="width: 200px;"></el-input>
				甲方姓名：<el-input v-model="enteruser.realname" disabled style="width: 200px;"></el-input>
			</div>
			
			<el-table :data="enterinfo" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="pay_kind" label="交易类型">
				</el-table-column>
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="enterpage" :size="10" :total="entertotal"
					@current-change="handleChangeenterPage"></Pageing>
			</div>
		</el-dialog>
		<el-dialog title="打赏交易详情" :visible.sync="golookrewardform">
			<div>
				甲方昵称：<el-input v-model="enteruser.enteruser" disabled style="width: 200px;"></el-input>
				甲方姓名：<el-input v-model="enteruser.realname" disabled style="width: 200px;"></el-input>
			</div>
			
			<el-table :data="enterinfo" style="width: 100%">
				<el-table-column type="index" width="50">
				</el-table-column>
				<el-table-column prop="start_time" label="日期">
				</el-table-column>
				<el-table-column prop="price" label="交易金额">
				</el-table-column>
				<el-table-column prop="bbeforewithdrawal" label="交易前余额">
				</el-table-column>
				<el-table-column prop="endwithdrawal" label="交易后余额">
				</el-table-column>
				<el-table-column prop="pay_kind" label="交易类型">
				</el-table-column>
				
				<el-table-column prop="remark" label="交易备注" ></el-table-column>
				
			</el-table>
			<div style="height: 80px;">
				<Pageing :page="enterpage" :size="10" :total="entertotal"
					@current-change="handleChangeenterPage"></Pageing>
			</div>
		</el-dialog>
    <!-- 处理提现申请 -->
    <el-dialog title="处理提现申请" :visible.sync="rechargeform">
      <el-form :model="forminfo">
        <el-form-item label="用户昵称" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.nickname"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.tel"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司名称" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.mechant_name"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="开户银行名称" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.mechant_blank"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="收款账号" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.mechant_blank_account"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现金额" :label-width="formLabelWidth">
          <el-input
            v-model="forminfo.price"
            disabled
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rechargeform = false">取 消</el-button>
        <el-button
          :loading="loading"
          type="primary"
          @click="submitpass(1, forminfo.order_num)"
          >{{ text }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DownloadExcel from "vue-json-excel";
import Cookie from "js-cookie";
import Pageing from "../../components/page/page.vue";
import {
  getadjustuserinfo,
  submitadd,
  getggrechargelist,
  rechargerefuse,
  rechargeagree,
  churechargeagree,
  entrustinfo,
  gongrechargerefuse,
} from "../../api/recharge.js";
export default {
  components: {
    Pageing,
    DownloadExcel,
  },
  data() {
    return {
      title: "提现统计导出",
      json_fields: {
        姓名: "enter_name",
        时间: "start_time",
        提现金额: "price",
        手机号: "tel",
        身份证: "user_idcard",
        类型: "declaretype",
        状态: "state_type",
      },
      loading: false,
      text: "确定",
      formLabelWidth: "120px",
      dialogFormVisible: false,
      rechargeform: false,
      golookentrustform: false,
      golookrewardform:false,
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      runmoney: 0,
      checkAll: false,
      formtype: "",
      form: {
        nickname: "",
        // tel: '',
        orderid: "",
        time: "",
      },
      moneyform: {
        incomemoney: 0,
        runwater: 0,
        paymoney: 0,
      },
      forminfo: {},
      userinfo: {
        name: "",
        id: "",
        tel: "",
        idcard: "",
      },
      useraddinfo: {
        user: "",
        money: "",
        remark: "",
      },
      userinfolist: [],
      userinfoid: "",
      userinfopage: 1,
      userinfosize: 10,
      userinfototal: 0,
      enterinfo: [],
      enteruser: {
        entername: "",
        enteruser: "",
        realname: "",
      },
      entertotal: 0,
      enterpage: 1,
      parentorder: "",
    };
  },
  mounted() {
    this.getuserlist();
  },
  methods: {
    openagree(e) {
      //console.log(e);
      this.forminfo = e;
      this.forminfo.mechant_name = e.mechant.name;
      this.forminfo.mechant_blank = e.mechant.blank;
      this.forminfo.mechant_blank_account = e.mechant.blank_account;
      //console.log(this.forminfo);
      this.rechargeform = true;
    },
    
    golookreward(val){
				
				this.golookrewardform = true
				this.parentorder = val.parent_order_num
				rewardinfo({
					'order':this.parentorder,
					'page':this.enterpage
				}).then(res=>{
					
					 this.enteruser.enteruser = res.usernick
					 this.enteruser.realname = res.realname
					 this.enterinfo = res.list
					
				})
				
			},
    golook(val) {
      this.golookentrustform = true;
      //this.parentorder == '' ? this.parentorder = val.parent_order_num:this.parentorder = this.parentorder
      this.parentorder = val.parent_order_num;
      console.log("golook---", this.parentorder);
      entrustinfo({
        order: this.parentorder,
        page: this.enterpage,
      }).then((res) => {
        //console.log(res);
        this.enteruser.entername = res.entername;
        this.enteruser.enteruser = res.usernick;
        this.enteruser.realname = res.realname;
        this.enterinfo = res.list.data;
        this.entertotal = res.list.total;
        this.enterpage = res.list.current_page;
      });
    },
    //确认提现
    submitrechargeform() {
      //console.log('确认提现');
      this.loading = true;
      this.text = "处理中";
      churechargeagree({
        token: Cookie.get("token"),
        order_id: this.forminfo.id,
      }).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.rechargeform = false;
          this.getuserlist();
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
        this.loading = false;
        this.text = "确定";
      });
    },
    submitpass(e, order) {
      this.$alert("确认该账户已转账！", "确认转账", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            gongrechargerefuse({
              token: Cookie.get("token"),
              type: e,
              order: order,
            }).then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: "success",
                });
                this.getuserlist();
              } else {
                this.$message({
                  message: res.msg,
                  type: "error",
                });
                this.getuserlist();
              }
            });
          } else {
            console.log("取消操作");
          }
        },
      });
    },
    openrefuse(e) {
      this.$alert("确认拒绝该账户提现！", "确认拒绝", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            rechargerefuse({
              token: Cookie.get("token"),
              order_id: e.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$message({
                  message: "拒绝成功",
                  type: "success",
                });
                this.getuserlist();
              }
            });
          } else {
            console.log("取消操作");
          }
        },
      });
    },
    //用户点击详情
    submituserinfo(e) {
      //console.log(e);
      this.userinfoid = e.uid;
      this.getuserinfo();
      this.dialogFormVisible = true;
    },
    getuserinfo() {
      getadjustuserinfo({
        uid: this.userinfoid,
        page: this.userinfopage,
      }).then((res) => {
        this.userinfo.name = res.name;
        this.userinfo.id = res.user;
        this.userinfo.tel = res.tel;
        this.userinfo.idcard = res.idcard;
        this.userinfolist = res.list.data;
        this.userinfototal = res.list.total;
      });
    },

    sumbmitadd() {
      submitadd({
        data: this.useraddinfo,
      }).then((res) => {
        console.log(res);
        //this.resetuseradd()
      });
    },
    getuserlist() {
      getggrechargelist({
        page: this.page,
        where: this.form,
        type: this.formtype,
      }).then((res) => {
        this.tableData = res.list;
        this.total = res.total;
      });
    },

    submitForm() {
      this.getuserlist();
    },
    handleChangePage(val) {
      this.page = val;
      this.getuserlist();
    },
    handleChangeuserPage(val) {
      this.userinfopage = val;
      this.getuserinfo();
    },
    handleChangeenterPage(val) {
      this.enterpage = val;
      //console.log(val);
      //console.log(this.parentorder);
      this.golook(this.parentorder);
    },
    resetForm() {
      this.$refs.userform.resetFields();
      this.form.nickname = "";
      this.form.tel = "";
      this.formtype = "";
      this.form.orderid = "";
      this.form.time = "";
      this.getuserlist();
    },

    close() {
      this.resetuseradd();
    },
    resetuseradd() {
      this.useraddinfo.user = "";
      this.useraddinfo.money = "";
      this.useraddinfo.remark = "";
    },
  },
};
</script>

<style lang="less" scoped>
.runmoney {
  display: flex;
  flex-direction: column;
  align-items: center;

  ul {
    display: flex;

    li {
      text-align: center;
      margin: 0 20px;
    }
  }
}
</style>
